<template>
  <span class="spinner-list" title="Loading...">
    <moon-loader></moon-loader>
  </span>
</template>

<script>
import MoonLoader from "vue-spinner/src/MoonLoader.vue";
export default {
  components: {
    MoonLoader
  }
};
</script>

<style>
.list-container {
  border: 1px solid #eee;
  border-radius: 2px;
  background: #fff;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row wrap;
  flex-flow: row wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
}
.v-moon.v-moon1 {
  margin-left: 40% !important;
}
/* .spinner-list {
  display: -webkit-flex;
  display: flex;
  flex: 0 1 auto;
  -webkit-flex-flow: row wrap;
  flex-flow: row wrap;
   width: 200px; 
  height: 200px;
  align-items: center;
  justify-content: center;
} */
</style>

